export const difficultyLevelLabel = [
  'Beginner',
  'Easy',
  'Normal',
  'Hard',
  'Impossible',
];
